module.exports = __webpack_public_path__ + "img/ImgCancle.265a29a6.svg";